var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './addPersonModal.scss';
var Modal = function (_a) {
    var show = _a.show, handleClose = _a.handleClose, children = _a.children;
    var showHideClassName = show ? "modal display-block" : "modal display-none";
    return (_jsx("div", __assign({ className: showHideClassName, onClick: handleClose }, { children: _jsx("div", __assign({ className: "modal-main", onClick: function (e) { return e.stopPropagation(); } }, { children: children })) })));
};
export default Modal;
